import _ from "lodash"

import { RecordMaskField, Wemi } from "@skinsoft/types"
import { getOnlyValuesFromMaskFields, removeWemiPrefix } from "@skinsoft/utils/mask-fields-utils"
import { cleanRefs, cleanValueToSort } from "@skinsoft/utils/es-types-helper"

import { wemi_metaRecordMask } from '@skinsoft/record-mask'

/**
 * checks if object is {} without countent props that are equal to null or "" as empty
 * @param object 
 * @returns 
 */
export function isEmptyObject(object) {
    if(_.isPlainObject(object)) {
        for(const key of Object.getOwnPropertyNames(object)) {
            if(object[key] !== undefined) {
                return false
            }
        }
        return true
    }

    return false
}

export function convertCachedWemiToWemi(wemiCached: Wemi): Wemi {
    let result: Wemi = {}

    let wemiCachedWithoutPrefix = removeWemiPrefix(wemiCached)
    wemiCachedWithoutPrefix = cleanRefs(wemiCachedWithoutPrefix)
    wemiCachedWithoutPrefix = cleanValueToSort(wemiCachedWithoutPrefix)

    const masks: RecordMaskField[] = wemi_metaRecordMask.categories.flatMap(category => category.maskFields) 
    
    const itemMasks = masks.filter(mask => {
        return mask.entityField.abstractEntity.toLowerCase().includes("item")
    })

    const manifestationMasks = masks.filter(mask => {
        return mask.entityField.abstractEntity.toLowerCase().includes("manifestation")
    })

    const expressionMasks = masks.filter(mask => {
        return mask.entityField.abstractEntity.toLowerCase().includes("expression")
    })

    const workMasks = masks.filter(mask => {
        return mask.entityField.abstractEntity.toLowerCase().includes("work")
    })


    const itemValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        itemMasks,
        //cleanValues
    )
    _.set(
        result,
        "item",
        itemValues
    )

    const manifestationValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        manifestationMasks,
        //cleanValues
    )
    _.set(
        result,
        "manifestation",
        manifestationValues
    )

    const expressionValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        expressionMasks,
        //cleanValues
    )
    _.set(
        result,
        "expression",
        expressionValues
    )

    const workValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        workMasks,
        //cleanValues
    )
    _.set(
        result,
        "work",
        workValues
    )

    // prevents to change inventory number offline
    _.unset(
        result,
        "item.identificationItemSchema.identifiers.0.identifier"
    )
    if(result.item?.identificationItemSchema?.identifiers === null || 
        (result.item?.identificationItemSchema?.identifiers && result.item.identificationItemSchema.identifiers.length === 0)
    ) {
        _.unset(
            result,
            "item.identificationItemSchema.identifiers"
        )
    }

    return result
}